var map = {
	"./article.svg": 1367,
	"./ask.svg": 5802,
	"./circle.svg": 3607,
	"./hot-search.svg": 2494,
	"./lesson.svg": 6265,
	"./live.svg": 2434,
	"./news.svg": 3713,
	"./resource.svg": 9984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3573;